import { render, staticRenderFns } from "./student-detail.vue?vue&type=template&id=dba3c41c&"
import script from "./student-detail.vue?vue&type=script&lang=ts&"
export * from "./student-detail.vue?vue&type=script&lang=ts&"
import style0 from "./student-detail.vue?vue&type=style&index=0&id=dba3c41c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports